module.exports = __webpack_public_path__ + "static/media/gallery11.44133cbc.jpg";